module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.user.is_activated) ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', {
    staticClass: "alert-text"
  }, [_vm._v("Please complete setup by activating your account. Your coverage cannot be activated without completing this step.")]), _vm._v(" "), _c('router-link', {
    staticClass: "color-theme alert-text",
    attrs: {
      "to": "/account-activation/step1"
    }
  }, [_vm._v("Click here to complete setup.")])], 1) : _vm._e(), _vm._v(" "), (_vm.justActivated) ? _c('Alert', {
    attrs: {
      "color": "green"
    }
  }, [_c('span', {
    staticClass: "alert-text"
  }, [_vm._v("Your account has been successfully activated.")]), _vm._v(" "), _c('router-link', {
    staticClass: "color-theme alert-text",
    attrs: {
      "to": "/account/security"
    }
  }, [_vm._v("Click here to set your password.")])], 1) : _vm._e(), _vm._v(" "), (_vm.devicesLoaded && _vm.devices.length === 0 && _vm.user.is_activated && _vm.user.coverage_item_covered !== 'PHONE') ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', {
    staticClass: "alert-text"
  }, [_vm._v("You currently have zero devices added to your account.")]), _vm._v(" "), _c('router-link', {
    staticClass: "color-theme alert-text",
    attrs: {
      "to": "/devices"
    }
  }, [_vm._v("Click here to add a device.")])], 1) : (_vm.devicesLoaded && _vm.devices.length === 0 && _vm.user.is_activated) ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', {
    staticClass: "alert-text"
  }, [_vm._v("Welcome to AKKO!")]), _vm._v(" "), _c('router-link', {
    staticClass: "color-theme alert-text",
    attrs: {
      "to": "/devices"
    }
  }, [_vm._v("Click here to add your phone to your protection plan.")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb1d699e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/alerts.vue
// module id = 1284
// module chunks = 0